import React, { useState, } from "react";
import { Box, Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";

const BrandMessageInput = () => {
    const user1 = sessionStorage.getItem("user");
    const user = JSON.parse(user1);
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);

    const sendMessage = async () => {
        if (!text.trim()) {
            toast.warning("Type a message");
            return;
        }

        try {
            setLoading(true);

            const payload = {
                text,
                role: "branding",
                senderId: user?._id,
                senderName: user?.username,
                // numbers: [
                //     "5656565656",
                //     "8050014177"
                // ]
            };

            let { data } = await axios.post(
                "https://chatb.qspiders.com/brand/newbrandsendmsg",
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${user?.TOKEN}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            toast.success(data.message);
            setText("");
        } catch (error) {
            console.error(error);
            toast.error("Failed to send message");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                gap: 1,
                padding: 1,
                borderTop: "1px solid #ddd",
                background: "#fff",
                alignItems: "flex-end",
            }}
        >
            <TextField
                fullWidth
                multiline
                minRows={2}
                maxRows={10}
                placeholder="Type your message..."
                value={text}
                onChange={(e) => setText(e.target.value)}
            // onKeyDown={(e) => {
            //     // Enter sends, Shift+Enter adds new line
            //     if (e.key === "Enter" && !e.shiftKey) {
            //         e.preventDefault();
            //         sendMessage();
            //     }
            // }}
            />

            <Button
                variant="contained"
                onClick={sendMessage}
                disabled={loading}
                sx={{ height: "40px" }}
            >
                {loading ? "Sending..." : "Send"}
            </Button>
        </Box>
    );
};

export default BrandMessageInput;
